// extracted by mini-css-extract-plugin
module.exports = {"questionBox":"Question_questionBox__36d06","Question":"Question_Question__3B8mu","Options":"Question_Options__2iGi8"};